import { Link } from 'react-router-dom';
import { articles } from '@/mocks/travelData';

export default function ArticleList() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-2">
              精选旅行攻略
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              最受欢迎的亚洲旅行指南与深度体验
            </p>
          </div>
          <Link
            to="/category/tropical-islands"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="w-full sm:w-48 md:w-56 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.coverUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-500">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/tropical-islands"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}